var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserHpAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 42,
    fill: "none",
    viewBox: "0 0 36 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_10910",
    width: 36,
    height: 42,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M0 0.39624H35.8522V41.7797H0V0.39624Z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_10910)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EE413C",
    fillRule: "evenodd",
    d: "M13.8771 0.866071C5.99143 2.449 -0.846948 10.446 0.085412 21.0922C1.01777 31.7388 9.43611 44.7117 28.3446 41.1908C36.1983 39.2969 35.4669 30.6108 35.096 26.328C34.7255 22.0456 37.9833 14.5434 33.2778 7.34715C28.5727 0.151278 19.4308 -0.24891 13.8771 0.866071Z",
    clipRule: "evenodd"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD91D",
    fillRule: "evenodd",
    d: "M6.88376 18.9679C2.85378 21.0025 2.88857 29.5966 7.9128 32.3884C12.9374 35.1803 20.2272 33.5858 21.4257 31.3658C23.233 28.0169 19.004 21.867 14.8713 19.6743C11.3728 17.8184 8.92444 17.9373 6.88376 18.9679Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3DFA2",
    fillRule: "evenodd",
    d: "M9.25058 21.4069C6.22011 22.9371 6.21687 28.7145 9.99525 30.8137C13.774 32.9133 18.6429 31.7754 19.515 30.0906C20.5352 28.1206 18.3655 23.5873 15.2573 21.9382C12.6265 20.5423 10.7852 20.6323 9.25058 21.4069Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD91D",
    fillRule: "evenodd",
    d: "M35.096 26.3279C34.8501 23.4849 36.2003 19.2235 35.7618 14.575C34.8901 13.0923 33.3866 12.5015 31.0231 13.7275C28.4999 15.0362 24.0699 20.3928 26.4944 27.0545C27.3811 29.4913 32.0591 30.323 34.6486 27.5962C34.8205 27.4151 34.9864 27.1813 35.1453 26.9083C35.1288 26.7082 35.1122 26.5125 35.096 26.3279Z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3DFA2",
    fillRule: "evenodd",
    d: "M30.4508 16.2076C28.5582 17.1895 25.8226 20.9596 27.6412 25.9568C28.3066 27.7846 31.2279 28.6567 33.1703 26.611C35.1818 24.4927 36.1825 13.2343 30.4508 16.2076Z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B122E",
    fillRule: "evenodd",
    d: "M17.6527 29.8734C16.5905 27.6047 13.321 26.221 11.2123 28.0651C11.021 28.2319 11.1601 28.6218 11.4421 28.5409C12.5298 28.2299 13.5827 27.888 14.7217 28.1562C15.8321 28.4177 16.7495 29.1289 17.3918 30.0383C17.4949 30.1841 17.7247 30.0276 17.6527 29.8734Z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B122E",
    fillRule: "evenodd",
    d: "M29.4524 26.1899C29.7966 24.1002 31.0283 22.7296 32.5197 21.304C32.6985 21.1324 32.5201 20.8273 32.277 20.9347C30.2525 21.8282 29.1972 24.0895 29.0022 26.1518C28.9751 26.4387 29.4067 26.468 29.4524 26.1899Z",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B122E",
    fillRule: "evenodd",
    d: "M29.1933 17.3493C28.4292 17.4127 27.7901 18.2119 27.3714 18.769C26.8148 19.5095 26.3088 20.3713 26.7473 21.2771C26.8816 21.5548 27.2412 21.7593 27.5587 21.6824C28.5505 21.4411 28.9158 20.6035 29.2131 19.7179C29.4356 19.0554 29.762 18.1326 29.4198 17.4626C29.3749 17.3746 29.2883 17.3414 29.1933 17.3493Z",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B122E",
    fillRule: "evenodd",
    d: "M13.5743 23.3365C13.8829 24.0117 14.814 24.3572 15.4742 24.6044C16.3738 24.9412 17.2572 25.2039 18.086 24.5977C18.3493 24.4047 18.4152 24.0045 18.2793 23.724C17.8409 22.8171 16.8697 22.6617 15.9284 22.611C15.2157 22.573 14.1652 22.5512 13.628 23.0928C13.5613 23.1602 13.5334 23.2474 13.5743 23.3365Z",
    clipRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD91D",
    fillRule: "evenodd",
    d: "M28.7523 29.5922C28.9213 29.1306 25.0151 22.915 23.6823 23.4115C22.5914 23.8188 21.74 31.716 22.3087 31.8127",
    clipRule: "evenodd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD91D",
    fillRule: "evenodd",
    d: "M25.8498 32.1085C23.1947 32.9113 18.7554 34.2521 19.8678 37.4148C20.8256 40.1369 25.8413 39.0988 27.6559 38.0658C29.2925 37.1347 33.2319 35.9848 32.7752 32.6878C32.3181 29.3908 27.2017 31.7 25.8498 32.1085Z",
    clipRule: "evenodd"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3DFA2",
    fillRule: "evenodd",
    d: "M25.9416 32.7925C23.9143 33.4054 20.525 34.4293 21.3741 36.8439C22.1054 38.9221 25.9351 38.1297 27.3205 37.3408C28.5704 36.6299 31.5778 35.7519 31.2292 33.2343C30.8805 30.7171 26.9739 32.4803 25.9416 32.7925Z",
    clipRule: "evenodd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3DFA2",
    fillRule: "evenodd",
    d: "M24.0615 24.3441C23.2744 24.6373 22.6604 30.3346 23.0705 30.4044C23.4807 30.4737 27.5968 29.1353 27.719 28.8024C27.8407 28.4696 25.0226 23.9859 24.0615 24.3441Z",
    clipRule: "evenodd"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M26.3095 34.1883C25.5572 34.3987 22.9324 34.0377 22.4426 34.8876C21.9527 35.7371 22.2104 37.6263 27.0712 36.2566C31.932 34.8864 30.7472 32.8062 29.785 32.6569C28.8227 32.5075 26.3095 34.1883 26.3095 34.1883Z",
    clipRule: "evenodd"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B122E",
    fillRule: "evenodd",
    d: "M24.7339 34.2814C24.8455 35.0731 24.9766 35.894 25.2023 36.6635C25.3884 36.6374 25.5837 36.6053 25.792 36.5648C25.6213 35.7993 25.4098 35.039 25.2371 34.2715C25.0753 34.2739 24.9062 34.277 24.7339 34.2814Z",
    clipRule: "evenodd"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B122E",
    fillRule: "evenodd",
    d: "M27.6479 33.3876C27.9461 34.1705 28.2422 34.9768 28.6317 35.7102C28.806 35.6338 28.9638 35.5565 29.1118 35.4784C28.859 34.6832 28.4812 33.905 28.135 33.1379C27.9695 33.218 27.8061 33.302 27.6479 33.3876Z",
    clipRule: "evenodd"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD91D",
    fillRule: "evenodd",
    d: "M22.5377 15.6993C22.5616 15.6993 22.5616 15.6632 22.5377 15.6632C22.5138 15.6632 22.5138 15.6993 22.5377 15.6993Z",
    clipRule: "evenodd"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD91D",
    fillRule: "evenodd",
    d: "M7.93276 13.1019C7.35191 12.6506 6.39932 12.7255 5.85245 13.1899C4.98926 13.9233 4.91726 15.2082 5.65991 16.057C6.13721 16.6026 6.79856 17.0776 7.56184 16.7298C8.02499 16.5194 8.42988 15.9642 8.61757 15.5011C8.98323 14.5996 8.69402 13.6935 7.93276 13.1019Z",
    clipRule: "evenodd"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD91D",
    fillRule: "evenodd",
    d: "M1.69726 16.2762C0.757619 16.4898 0.059462 17.3627 0.255237 18.3338C0.512091 19.6069 1.78706 20.292 3.04139 20.0503C4.16751 19.8327 4.65573 18.7051 4.25771 17.7129C3.86656 16.7386 2.78333 16.0294 1.69726 16.2762Z",
    clipRule: "evenodd"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD91D",
    fillRule: "evenodd",
    d: "M1.51662 24.608C1.94134 24.5711 2.24957 24.3702 2.56265 24.106C3.09658 23.6551 2.864 22.9609 2.30782 22.6772C2.37375 22.7101 2.3604 22.7013 2.26777 22.651C2.15977 22.5841 2.04732 22.5238 1.93123 22.4707C1.70188 22.3875 1.33784 22.3582 1.09797 22.4022C0.787726 22.4584 0.500939 22.6554 0.316895 22.9157C0.39658 23.4007 0.492041 23.888 0.602872 24.3766C0.861748 24.5521 1.1906 24.6361 1.51662 24.608Z",
    clipRule: "evenodd"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD91D",
    fillRule: "evenodd",
    d: "M31.7983 7.75486C30.7073 8.57703 30.9957 10.1136 31.9969 10.8538C32.3698 11.1295 32.9511 11.183 33.3661 10.9683C33.9053 10.6893 34.3292 10.1627 34.4922 9.5886C34.1872 8.896 33.8199 8.2026 33.3798 7.51158C32.8677 7.3202 32.3051 7.3733 31.7983 7.75486Z",
    clipRule: "evenodd"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD91D",
    fillRule: "evenodd",
    d: "M14.0024 8.21639C15.5123 9.20775 16.3084 10.6476 16.5135 12.4097C16.6562 13.6336 16.3517 15.2906 16.8973 16.4258C17.2949 17.2535 18.3159 17.6066 18.8939 16.7503C18.9044 16.7353 18.8878 16.7166 18.8709 16.7234C17.6278 17.2381 17.9276 13.4089 17.9199 12.966C17.9037 12.0435 17.8277 11.1207 17.5243 10.2411C16.9993 8.7196 15.8679 7.45088 14.4914 6.5986C12.9871 5.66707 11.1903 5.22964 9.42955 5.10443C8.3455 5.02677 7.11018 5.11473 5.96546 5.00537C5.40402 5.5272 4.8717 6.09024 4.37256 6.69171C4.56712 6.75154 4.76451 6.80424 4.96352 6.84426C8.05265 7.46514 11.1507 6.34422 14.0024 8.21639Z",
    clipRule: "evenodd"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD91D",
    fillRule: "evenodd",
    d: "M19.8956 6.06518C19.6323 7.68971 19.8726 9.38872 20.7386 10.8092C21.1564 11.4951 21.7061 12.0644 22.2999 12.6049C22.8051 13.0653 25.9545 15.1736 24.733 15.9558C24.7192 15.9645 24.7281 15.9875 24.7435 15.9879C26.0609 16.0295 26.2102 14.7758 25.5638 13.8752C24.8304 12.8541 23.6744 12.1556 22.8444 11.213C21.5957 9.79565 21.1678 8.15091 21.5536 6.31678C22.0123 4.13635 23.4382 2.74084 24.7706 1.22606C24.0312 1.01012 23.2841 0.838951 22.5374 0.712158C22.5196 0.733554 22.501 0.755347 22.4836 0.776743C21.2341 2.3141 20.214 4.10267 19.8956 6.06518Z",
    clipRule: "evenodd"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD91D",
    fillRule: "evenodd",
    d: "M14.2213 4.04262C14.2476 4.0347 14.2621 3.98873 14.2265 3.98081C13.2145 3.75654 12.2348 3.51603 11.3494 2.95934C10.9493 2.70773 10.6011 2.39036 10.2471 2.0813C9.88874 2.25168 9.53643 2.43909 9.18896 2.63681C9.74231 2.96845 10.2204 3.40113 10.815 3.70186C11.8615 4.23122 13.0948 4.37624 14.2213 4.04262Z",
    clipRule: "evenodd"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD91D",
    fillRule: "evenodd",
    d: "M18.1034 2.76708C18.0913 2.78095 18.1107 2.79878 18.1253 2.79244C19.2837 2.30627 19.6356 1.47459 19.9876 0.431721C19.5996 0.411117 19.2158 0.400815 18.8352 0.398438C18.8894 1.21466 18.7733 2.0091 18.1034 2.76708Z",
    clipRule: "evenodd"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD91D",
    fillRule: "evenodd",
    d: "M24.0577 9.3226C24.0742 9.34835 24.1224 9.34795 24.1236 9.31071C24.1709 7.8209 24.0144 6.47095 24.6292 5.05009C25.1563 3.83129 26.0959 2.91046 27.135 2.10177C26.8657 1.97814 26.593 1.86443 26.3184 1.75586C23.9557 3.32927 22.4672 6.80973 24.0577 9.3226Z",
    clipRule: "evenodd"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD91D",
    fillRule: "evenodd",
    d: "M3.35081 10.5792C5.89589 10.746 10.6208 8.79498 12.3027 11.1933C12.4718 11.4342 12.867 11.1747 12.7375 10.9192C11.9621 9.3913 10.4388 9.04619 8.80825 8.93089C7.2821 8.82311 4.84704 9.05332 3.01549 8.55249C2.64659 9.13177 2.30358 9.73523 1.99414 10.3648C2.41603 10.4829 2.88079 10.5483 3.35081 10.5792Z",
    clipRule: "evenodd"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#EE413C",
    fillRule: "evenodd",
    d: "M13.8769 0.865716C8.22613 2.00011 3.11453 6.42874 1.01318 12.7652C1.32019 12.3499 1.64864 11.9494 1.98842 11.565C5.29112 7.83138 9.80366 5.14021 14.7057 3.98006C19.6082 2.8199 24.8771 3.19592 29.5559 5.04075C30.6796 5.48374 31.7734 6.02023 32.7963 6.65696C27.9715 0.12715 19.247 -0.21202 13.8769 0.865716Z",
    clipRule: "evenodd"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    fillRule: "evenodd",
    d: "M7.19971 36.2C11.7842 40.4896 18.6991 42.987 28.3447 41.1909C33.2099 40.0173 34.7793 36.2373 35.1818 32.512C32.104 37.1759 29.7309 38.5996 23.3969 39.1519C15.7564 39.8192 12.3125 37.8301 7.19971 36.2Z",
    clipRule: "evenodd",
    opacity: 0.01
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserHpAvatar);
export default __webpack_public_path__ + "static/media/user_hp_avatar.c154f77041cd2dc4f5bbc6f78ecbaabd.svg";
export { ForwardRef as ReactComponent };